import { Option } from '@spike/model';

export const Unpaid = { id: 'unpaid', name: 'Unpaid' };
export const partiallyPaid = { id: 'partially_paid', name: 'Partially Paid' };
export const Paid = { id: 'paid', name: 'Paid' };
export const Voided = { id: 'voided', name: 'Voided' };
export const All = { id: 'all', name: 'All' };
export const Draft = { id: 'draft', name: 'Draft' };

export const categories: Array<Option<string>> = [Unpaid, partiallyPaid, Paid, Voided, All, Draft];

export const paid = 'paid';
export const unpaid = 'unpaid';
export const partially_paid = 'partially_paid';
export const voided = 'voided';
export const refunded = 'refunded';
export const overpaid = 'overpaid';
export const draft = 'draft';
export const issued = 'issued';

export const getCategoryStatuses = (categoryId: string) => {
    switch (categoryId) {
        case Paid.id:
            return [paid, overpaid];
        case Unpaid.id:
            return [unpaid];
        case partiallyPaid.id:
            return [partially_paid];
        case Voided.id:
            return [voided];
        case All.id:
            return [issued];
        case Draft.id:
            return [draft];
        default:
            return [];
    }
};
